<template>
    <div>
        <named-value :name="fromTo" />

        <spacer />

        <named-value :name="texts.valid_from">
            {{ validFrom | momentDateAndTime }}
        </named-value>

        <named-value :name="texts.valid_to">
            {{ validTo | momentDateAndTime }}
        </named-value>

        <spacer />

        <named-value
            :name="title"
            variant="stacked"
        />
        <named-value
            v-for="passenger in passengers"
            :key="passenger.id"
            secondary
        >
            {{ passenger.count }} {{ passenger.name }}
        </named-value>

        <spacer />

        <named-value :name="texts.from_zone">
            {{ startZone }} ({{ startZoneName }})
        </named-value>

        <named-value
            v-if="viaZone !== null"
            :name="texts.via_zone"
        >
            {{ viaZone }} ({{ viaZoneName }})
        </named-value>

        <named-value :name="texts.to_zone">
            {{ endZone }} ({{ endZoneName }})
        </named-value>

        <named-value :name="texts.total_zones">
            {{ zoneDistance }}
        </named-value>
    </div>
</template>

<script>
import NamedValue from "@/components/elements/NamedValue";

export default {
    components: {
        NamedValue
    },
    props: {
        texts: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        startStop: {
            type: String,
            required: true
        },
        endStop: {
            type: String,
            required: true
        },
        viaStop: {
            type: String,
            default: null
        },
        validFrom: {
            type: Object,
            required: true
        },
        validTo: {
            type: Object,
            required: true
        },
        passengers: {
            type: Array,
            required: true
        },
        startZone: {
            type: Number,
            required: true
        },
        startZoneName: {
            type: String,
            required: true
        },
        endZone: {
            type: Number,
            required: true
        },
        endZoneName: {
            type: String,
            required: true
        },
        viaZone: {
            type: Number,
            default: null
        },
        viaZoneName: {
            type: String,
            default: null
        },
        zoneDistance: {
            type: Number,
            required: true
        }
    },
    computed: {
        fromTo() {
            return [this.startStop, this.viaStop, this.endStop]
                .filter(Boolean)
                .join(" → ");
        }
    }
};
</script>
